import type { EnvironmentVariables } from './types'

export const environment: EnvironmentVariables =
  typeof window === 'undefined'
    ? process.env
    : window.__remixContext.state.loaderData!.root.env
